import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogCTA.css';

const BlogCTA = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 5000);
    }
  };

  return (
    <section className="blog-cta-section">
      <div className="blog-cta-container">
        <div className="blog-cta-row">
          {/* CTA */}
          <div className="blog-cta-left">
            <h4 className="cta-subtitle">Get In Touch</h4>
            <h2 className="cta-title">Need Professional Electrical Services?</h2>
            <p className="cta-description">
              Contact us today for expert advice, free consultations, and quality electrical solutions tailored to your needs.
            </p>
            <div className="cta-buttons">
              <a href="tel:0796049254" className="cta-btn primary">📞 Call Now</a>
              <Link to="/contact" className="cta-btn secondary">Get a Quote</Link>
            </div>
          </div>

          {/* Subscribe */}
          <div className="blog-cta-right">
            <div className="subscribe-box">
              <h3>Subscribe to Our Newsletter</h3>
              <p>Get the latest articles, tips, and electrical insights delivered to your inbox.</p>
              {subscribed ? (
                <div className="subscribe-success">
                  <span>✓</span> Thank you for subscribing!
                </div>
              ) : (
                <form className="subscribe-form" onSubmit={handleSubscribe}>
                  <input 
                    type="email" 
                    placeholder="Your email address" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="subscribe-input"
                  />
                  <button type="submit" className="subscribe-btn">Subscribe</button>
                </form>
              )}
              <p className="subscribe-note">No spam, unsubscribe anytime.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="blog-cta-golden-line"></div>
    </section>
  );
};

export default BlogCTA;
